import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "3",
  navbarHook: "mounted",
  loadMethods: ["loadEstimates"],
});
